module.exports = __webpack_public_path__ + "images/wappen-harmonie-muenchen-blau-cc80ec4940d338b2db3f177339054932.png";